import React from 'react'

import Layout from '../components/layout'
import SEO from '../components/seo'
import Breadcrumb from '../components/breadcrumb'
import SectorPage from '../components/sectorPage'

const BeautyPage = ({location}) => {
  return (
    <Layout simpleHeader={true} url="/beaute" type="sector">
      <SEO 
        title="Classement des meilleurs sites du secteur de la beauté"
        description="Quels sont les meilleurs sites du secteur de la beauté de l'Observatoire de l'impact positif ? Découvrez les résultats de L’Occitane, Yves Rocher, Clarins, Nuxe, et L’Oréal."
        path="/beaute" />
      
      <Breadcrumb url="/beaute" label="Beauté" />

      <SectorPage slug="beauty" type="sector" />
    </Layout>
  )
  }

export default BeautyPage

